export const MFA_REGISTER_KEY_COMPATIBILITY_MESSAGE =
  "If you're experiencing issues with registering keys, or using built-in authenticators like Touch ID or Windows Hello, consider trying a different browser or using an external key.";
export const MFA_USING_KEY_COMPATIBILITY_MESSAGE =
  "If you're experiencing issues using keys, or built-in authenticators like Touch ID or Windows Hello, consider trying a different browser or using an external key.";
